/**
 * @name v0.1.0版本过渡
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2020-4-21
 * 
*/
// 导入v0.0.5数据格式
import * as v009 from './v009.js';

export const upgrade = function ( formData ) {
    // 取出当前版本
    let { version } = formData;
    /** 
     * 如果当前版本为v0.1.0,则该数据不需要更新直接抛出,
     * 否则先将数据格式化为v0.0.9数据在进行处理
     *
    **/
    if ( version == '0.1.0') return formData;
    // 把数据按照v005版本格式化数据，然后在进行处理
    let currentData = v009.upgrade(formData);
    // 取出表单项字典,给需要添加showRule(显示设置)配置的表单项添加该配置
    let { formMap } = currentData;
    // 需要添加nullRender 配置的组件类型
    let includeColorRender = ['text','input','textarea', 'radio','checkbox','select','switch','datePicker','timePicker'];
    // 添加配置
    for ( let key in formMap) {
        let { type } = formMap[key].node;
        if (includeColorRender.includes(type)) {
            formMap[key].renderOption.whereColor = 'all';
            formMap[key].renderOption.renderColor = '#5c5c5c';

        }
        type == 'text' && (formMap[key].styleOption.color = '#5c5c5c');
    }
    // 版本号更新
    currentData.version = '0.1.0';
    return currentData;
}


// WEBPACK FOOTER //
// ./src/assets/version/v010.js